import { Activity } from '@vendasta/automata';
import { CrmObjectInterface } from '@vendasta/crm/lib/_internal/interfaces/crm-objects.interface';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { CrmFieldService, CrmObjectDisplayService } from '@galaxy/crm/static';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { Observable } from 'rxjs';
import { AutomationsRouterService } from '../automations-router.service';

interface ActivityRow {
  activity: Activity;
  customObject?: CrmObjectInterface;
}

@Component({
  selector: 'automata-crm-custom-object-cell',
  template: `
    <a class="title" target="_blank" [href]="url$ | async" [ngClass]="{ deleted: !element.customObject?.crmObjectId }">
      {{ customObjectName }}
    </a>
  `,
  styleUrls: ['./crm-custom-object-cell.component.scss'],
  providers: [CrmFieldService],
  imports: [CommonModule, TranslateModule],
})
export class CrmCustomObjectCellComponent implements OnInit, CustomCellComponent<ActivityRow> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() translateService: TranslateService;
  @Input() element: ActivityRow;
  @Input() eventEmitter: EventEmitter<any>;

  customObjectName: string;
  url$: Observable<string>;

  constructor(
    private readonly objectDisplayService: CrmObjectDisplayService,
    private automationsRouterService: AutomationsRouterService,
  ) {}

  ngOnInit(): void {
    if (!this.element.customObject?.crmObjectId) {
      this.customObjectName = this.translateService.instant('AUTOMATIONS.COMMON.DELETED');
      return;
    }
    this.customObjectName = this.objectDisplayService.getObjectDisplayName('CustomObject', this.element.customObject);
    this.url$ = this.automationsRouterService.applyRoutePrefix(
      `/crm/custom-object/${this.element.customObject.crmObjectSubtype}/profile/${this.element.customObject.crmObjectId}`,
    );
  }
}
